export enum CryptoName {
  Getresponse = 'getresponse',
}
